import { render } from "./RegionalDesign.vue?vue&type=template&id=6f7cfc00&scoped=true"
import script from "./RegionalDesign.vue?vue&type=script&lang=js"
export * from "./RegionalDesign.vue?vue&type=script&lang=js"

import "./RegionalDesign.vue?vue&type=style&index=0&id=6f7cfc00&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f7cfc00"]])

export default __exports__